module.exports = __webpack_public_path__ + "lt_LT-header-b51de0.webp";